module.exports = __webpack_public_path__ + "img/product3.37e7a603.jpg";